
import { SectionTitle } from "@/components/section-title";
import { consultingBenefits } from "../constants";
import type { Benefit } from "../constants";
import { CheckCircle2 } from "lucide-react";

export function Benefits() {
    return (
        <section id="beneficios" className="grid gap-8 scroll-mt-28">
            <SectionTitle
                eyebrow="Benefícios"
                title="Por que implementar com a CodeBoost?"
                subtitle="Nossos especialistas diagnosticam oportunidades ocultas para alocação de tecnologias avançadas com aprendizado contínuo."
            />
            <div className="grid gap-4 md:grid-cols-3">
                {consultingBenefits.map((benefit: Benefit) => (
                    <div key={benefit.title} className="flex flex-col gap-4 rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 p-6 transition-all hover:border-cyan-500/30 hover:shadow-[0_0_30px_rgba(6,182,212,0.1)]">
                        <div className="h-12 w-12 rounded-full bg-cyan-500/10 flex items-center justify-center border border-cyan-500/20">
                            <CheckCircle2 className="h-6 w-6 text-cyan-600 dark:text-cyan-400" />
                        </div>
                        <div className="space-y-2">
                            <p className="font-semibold text-xl text-slate-900 dark:text-white">{benefit.title}</p>
                            <p className="text-slate-600 dark:text-slate-200/70 leading-relaxed">{benefit.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
